export const productsByTable = {
	label: "Saída de produtos em mesa",
};
